import { LOCALES } from '@/constants/locales'
import PAGES from '@/constants/pages'
import type { NextRouter } from 'next/router'

const { PREFIX, ...BYDB_PAGES } = PAGES.CLIENT.BYDB

export const BYDB_ROOT_MARKET_PATHS = ['/', ...Object.values(BYDB_PAGES)]

export const getBydbInternalPath = (locale: string, page = '') =>
  `${PREFIX}/${locale}${page}`

export const getBydbPublicPath = (locale: string, page = '') =>
  locale === LOCALES.US ? page || '/' : getBydbInternalPath(locale, page)

export const getBydbRootMarketRewritePath = (pathname: string) => {
  if (!BYDB_ROOT_MARKET_PATHS.includes(pathname)) {
    return null
  }

  return getBydbInternalPath(
    LOCALES.US,
    pathname === PAGES.CLIENT.ROOT ? '' : pathname,
  )
}

export const navigateToBydbPage = (
  router: NextRouter,
  locale: string,
  page: string,
  query: NextRouter['query'],
) =>
  router.push(
    {
      pathname: getBydbInternalPath(locale, page),
      query,
    },
    {
      pathname: getBydbPublicPath(locale, page),
      query,
    },
  )
